{
    "title":"Corporate Ownership",
    "subtitle":"All beneficial owner owning 20% or more have to be included. You can add more than one company individuals.",
    "input":{
        "title": "Title",
        "individualtype": "Individual Type",
        "percentageownership": "Percentage Ownership (%)",
        "relationshipestablishedat": "Relationship Established At"
    }
}